import React, { useState, useEffect } from "react";
import { useNavigate, Link, useParams } from "react-router-dom";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import { Card, CardBody, Col, Container, Input, Label, Row } from "reactstrap";

import api from "../../services/api";

// import images
import logo from "../../assets/images/logo.svg";
import lightlogo from "../../assets/images/logo-light.svg";
import as3logo from "../../assets/images/as3-engenharia-menor-2.png";

export default function DefinirNovaSenha() {
  let params = useParams();
  const regex = /^(?=.*[@$!%*#?\\])[@$!%*#?\\a-zA-Z0-9]{8,20}$/;
  const [usuario, setUsuario] = useState({ senha: "", repetir_senha: "" });
  const [isTokenRefreshValid, setIsTokenRefreshValid] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    api
      .get(`/redefinir-senha/${params.refreshToken}`)
      .then((response) => {
        setIsTokenRefreshValid(response.data.isTokenRefreshValid);
      })
      .catch((err) => {});
  });

  function validateForm() {
    return (
      regex.test(usuario.senha) &&
      regex.test(usuario.repetir_senha) &&
      usuario.senha === usuario.repetir_senha
    );
  }

  function onChange(event) {
    const { value, name } = event.target;

    setUsuario({
      ...usuario,
      [name]: value,
    });
  }

  async function handleSubmit(event) {
    event.preventDefault();
    try {
      api
        .post(`/redefinir-senha/${params.refreshToken}`, usuario)
        .then((response) => {
          setIsTokenRefreshValid(response.data.isTokenRefreshValid);

          navigate("/login");
        })
        .catch((err) => {});
    } catch (e) {}
  }

  return (
    <React.Fragment>
      <div className="account-pages my-5 pt-sm-5">
        <Container>
          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <Card className="overflow-hidden">
                <div className="bg-primary bg-soft">
                  <Row>
                    <Col className="col-7">
                      {isTokenRefreshValid ? (
                        <>
                          <div className="text-primary p-4">
                            <h5 className="text-primary">
                              Redefinição de senha
                            </h5>{" "}
                            <p>Informe sua nova senha nos campos abaixo</p>
                          </div>
                        </>
                      ) : (
                        <>
                          <div className="text-primary p-5">
                            <h5 className="text-primary">Link inválido</h5>
                          </div>
                        </>
                      )}
                    </Col>
                  </Row>
                </div>
                <CardBody className="pt-0">
                  {/* Logo do AS3 Agile Board */}
                  <div className="auth-logo">
                    <div className="auth-logo-light">
                      <div className="avatar-md profile-user-wid mb-4">
                        <span className="avatar-title rounded-circle bg-light">
                          <img
                            src={lightlogo}
                            alt=""
                            className="circle"
                            height="34"
                          />
                        </span>
                      </div>
                    </div>
                    <div className="auth-logo-dark">
                      <div className="avatar-md profile-user-wid mb-4">
                        <span className="avatar-title rounded-circle bg-light">
                          <img
                            src={logo}
                            alt=""
                            className="circle"
                            height="34"
                          />
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="p-2">
                    {isTokenRefreshValid ? (
                      <Form className="form-horizontal" onSubmit={handleSubmit}>
                        <div className="mb-3">
                          <Label for="senha">Senha</Label>
                          <Input
                            name="senha"
                            type="password"
                            className="form-control"
                            placeholder="Insira a sua nova senha"
                            onChange={onChange}
                            required
                          />
                          {regex.test(usuario.senha) ? null : (
                            <span className="text-danger">
                              {" "}
                              A senha precisa ter pelo menos 8 caracteres, uma
                              letra maiúscula, uma letra minúscula e um
                              caractere especial (@$!%*#\)
                            </span>
                          )}
                        </div>
                        <div className="mb-3">
                          <Label for="senha">Repetição da senha</Label>
                          <Input
                            name="repetir_senha"
                            type="password"
                            className="form-control"
                            placeholder="Confirme a sua nova senha"
                            onChange={onChange}
                            required
                          />
                          {usuario.senha === usuario.repetir_senha ? null : (
                            <span className="text-danger">
                              {" "}
                              As senhas não conferem. Verifique se houve um erro
                              de digitação.
                            </span>
                          )}
                        </div>
                        <div className="mt-3 d-grid">
                          <Button
                            className="btn btn-primary btn-block"
                            size="lg"
                            type="submit"
                            disabled={!validateForm()}
                          >
                            Gravar
                          </Button>
                        </div>

                        <div className="mt-4 text-center">
                          <p>
                            <i className="bx bxs-lock" /> Lembrou da senha?{" "}
                            <Link
                              to="/login"
                              className="font-weight-medium text-primary"
                            >
                              Clique aqui
                            </Link>{" "}
                          </p>
                        </div>
                      </Form>
                    ) : (
                      <div className="mt-2 text-center">
                        <p>O link informado é inválido ou está expirado</p>
                      </div>
                    )}
                  </div>
                </CardBody>
              </Card>
              <div className=" text-center">
                <p>
                  © {new Date().getFullYear()} AS3 Agile Board. Feito com{" "}
                  <i className="mdi mdi-heart text-danger" /> e{" "}
                  <i className="mdi mdi-coffee text-brown" /> por{" "}
                  <a
                    href="https://as3engenharia.com.br/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src={as3logo}
                      alt="AS3 Engenharia"
                      title="AS3 Engenharia"
                      height="30"
                    />
                  </a>
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
}
